import { Table, Button, Divider } from 'antd/lib';
import React from 'react';

class TablaTalonarios extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.talonarios,
      textoBuscarNombre: '',
      filtered: false,
    };
  }

  render() {
    const columns = [
      {
        title: 'Codigo',
        dataIndex: 'codigo',
        key: 'codigo',
      },
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
        sortOrder: 'ascend',
        sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      },
      {
        title: 'Numero Actual',
        dataIndex: 'cantidad',
        key: 'cantidad',
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              onClick={() =>
                this.props.history.push(`/admin/otros/talonarios/${record._id}`)
              }
            >
              Editar
            </Button>
            <Divider type="vertical" />
            <Button
              type="danger"
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    const { talonarios } = this.props;
    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={false}
        dataSource={talonarios}
        title={() => <h2 style={{ textAlign: 'center' }}> Talonarios </h2>}
        locale={{
          emptyText: 'No hay talonarios cargados',
        }}
      />
    );
  }
}

export default TablaTalonarios;
